import React from 'react';
import styles from './Title.module.scss';

const Title = ({ children, ...props }) => {
    return (
        <h2 className={styles.title} {...props}>
            {children}
        </h2>
    );
};

export default Title;
